import MpBaseWidget from '../../MpBaseWidget.js';

export default class MpUploadButton extends MpBaseWidget {

	/** @type {string} */
	static NAME = 'MpUploadButton';

	/**
	 * @type {DynamicWidgetConfig}
	 */
	static config = {
		name: 'upload-button', // must match the parent folder name
		optionsDataName: 'uploadButton', // js data name
		selector: 'button[data-upload-button],a[data-upload-button]', // css selector
		sideEffects: false,
		allowReInit: false,
	};
}
